import React, { createContext, useContext, useState, useCallback } from "react";

export const STRINGS = {
    it: {
        nav: { home: "Home", services: "Servizi", projects: "Progetti", contact: "Contatti", quote: "Richiedi Preventivo", company: "Azienda", team: "La Nostra Squadra", certifications: "Certificazioni", contoTermico: "Conto Termico 3.0" },
        hero: {
            overline: "Impianti tecnologici · dal 2001",
            l1: "Realizziamo impianti",
            l2: "tecnologici",
            l3: "per il futuro.",
            sub: "Da oltre 20 anni progettiamo e realizziamo impianti idraulici, termici, antincendio e tecnologici per aziende, industrie ed enti pubblici.",
            cta1: "Richiedi Preventivo",
            cta2: "I Nostri Lavori",
            scroll: "Scorri",
        },
        about: {
            chapter: "01 — Chi Siamo",
            title: "Esperienza, Innovazione e Qualità",
            p1: "Gruppo CB srl opera nel settore impiantistico dal 2001. Ci occupiamo di installazione e riparazione di impianti idrotermosanitari, gas e condizionamento.",
            p2: "Lavoriamo in tutta Italia con personale specializzato. Il nostro costante aggiornamento tecnico si traduce nella ricerca di prodotti innovativi e all'avanguardia.",
            stats: [
                { value: 20, suffix: "+", label: "Anni di esperienza" },
                { value: 500, suffix: "+", label: "Impianti realizzati" },
                { value: 100, suffix: "%", label: "Team qualificato" },
                { value: 24, suffix: "/7", label: "Assistenza continua" },
            ],
        },
        services: { chapter: "02 — Servizi", title: "Cosa Realizziamo", sub: "Soluzioni impiantistiche complete, civili ed industriali.", more: "Scopri di più" },
        why: {
            chapter: "03 — Perché Sceglierci",
            title: "Perché scegliere Gruppo CB",
            items: {
                certified: "Personale certificato",
                quality: "Materiali di qualità",
                innovation: "Tecnologie innovative",
                compliance: "Rispetto delle normative",
                onTime: "Tempi certi",
                aftersales: "Assistenza post-vendita",
            },
        },
        esco: {
            chapter: "Certificazione ESCo",
            badge: "UNI CEI 11352",
            title: "Energy Service Company certificata",
            p: "Gruppo CB è una ESCo (Energy Service Company) certificata secondo la norma UNI CEI 11352. Non ci limitiamo a installare impianti: progettiamo e realizziamo interventi di efficientamento energetico garantendo i risultati, gestendo gli incentivi e proponendo soluzioni di finanziamento.",
            items: [
                { t: "Diagnosi e progettazione energetica", d: "Analisi dei consumi e piani di efficientamento su misura." },
                { t: "Risparmio garantito", d: "Risultati assicurati tramite Contratti di Prestazione Energetica (EPC)." },
                { t: "Gestione degli incentivi", d: "Certificati Bianchi (TEE), Conto Termico e detrazioni fiscali." },
                { t: "Finanziamento tramite terzi", d: "Interventi realizzabili senza investimento iniziale del cliente." },
            ],
            cta: "Scopri come risparmiare energia",
        },
        portfolio: { chapter: "04 — Portfolio", title: "I Nostri Lavori", sub: "Una selezione dei progetti realizzati.", all: "Tutti", view: "Vedi tutti i progetti" },
        clients: { title: "Aziende e partner che ci hanno scelto" },
        reviews: { chapter: "05 — Testimonianze", title: "La voce dei nostri clienti" },
        offices: {
            chapter: "06 — I Nostri Uffici",
            title: "I Nostri Uffici",
            sub: "Spazi moderni e accoglienti dove nascono i nostri progetti. Passa il mouse (o tocca) per esplorare.",
            hint: "Passa il mouse per esplorare",
            items: [
                { tag: "Spazi Operativi", title: "Uffici Luminosi", desc: "Ambienti di lavoro moderni con pareti vetrate e finiture di design, pensati per la concentrazione e la collaborazione." },
                { tag: "Reception", title: "Accoglienza Gruppo CB", desc: "Un ingresso curato e brandizzato dove accogliamo clienti e partner con professionalità." },
                { tag: "Area Clienti", title: "Comfort & Design", desc: "Spazi confortevoli e ordinati che raccontano la cura e l'attenzione al dettaglio della nostra azienda." },
            ],
        },
        finalCta: { title: "Hai un progetto da realizzare?", sub: "Contattaci per una consulenza gratuita e senza impegno.", btn: "Richiedi un Preventivo Gratuito" },
        servicesPage: { title: "I Nostri Servizi", sub: "Impianti civili ed industriali progettati e realizzati a regola d'arte.", process: "Processo di lavoro", faq: "Domande frequenti", benefits: "Vantaggi", askQuote: "Richiedi un preventivo per questo servizio" },
        process: [
            { t: "Pianificazione", d: "Analisi delle esigenze e progettazione su misura." },
            { t: "Acquisti", d: "Selezione di materiali certificati e all'avanguardia." },
            { t: "Esecuzione", d: "Installazione con personale specializzato." },
            { t: "Coordinamento", d: "Gestione della commessa in ogni fase." },
            { t: "Collaudo", d: "Verifiche e test a norma di legge." },
            { t: "Consegna", d: "Impianto ultimato e assistenza continua." },
        ],
        faq: [
            { q: "In quali zone operate?", a: "Lavoriamo in tutta Italia con personale specializzato, con sede operativa in Umbria." },
            { q: "Rilasciate le certificazioni?", a: "Sì, tutti i nostri impianti vengono collaudati e certificati a norma di legge." },
            { q: "Offrite assistenza post-vendita?", a: "Certo. Siamo centro assistenza autorizzato Ariston, Ferroli e Haier con contratti di manutenzione programmata." },
            { q: "Posso accedere agli incentivi?", a: "Vi supportiamo nell'accesso agli incentivi come il Conto Termico per l'efficientamento energetico." },
        ],
        projectsPage: { title: "Progetti", sub: "Filtra per categoria ed esplora i lavori realizzati.", year: "Anno", client: "Cliente", tech: "Tecnologie" },
        contactPage: {
            title: "Contatti", sub: "Siamo a tua disposizione per preventivi, sopralluoghi e consulenze.",
            phone: "Telefono", email: "Email", address: "Indirizzo", hours: "Orari",
            hoursValue: "Lun–Ven 8:00–18:00 · Sab su appuntamento",
        },
        form: {
            name: "Nome e cognome", email: "Email", phone: "Telefono", service: "Servizio di interesse", subject: "Oggetto", message: "Messaggio",
            send: "Invia richiesta", sending: "Invio in corso...", selectService: "Seleziona un servizio",
            success: "Richiesta inviata! Ti ricontatteremo al più presto.", error: "Errore nell'invio. Riprova o chiamaci.",
            required: "Campo obbligatorio",
        },
        footer: { tagline: "Impianti civili ed industriali · idro-termosanitari, gas e condizionamento.", nav: "Navigazione", services: "Servizi", contacts: "Contatti", rights: "Tutti i diritti riservati.", quote: "Richiedi un preventivo o un sopralluogo" },
        contoTermico: {
            chapter: "Incentivi",
            title: "Conto Termico 3.0",
            sub: "L'incentivo statale per l'efficienza energetica e le rinnovabili termiche. Ti seguiamo dalla progettazione alla pratica GSE.",
            intro: "Il Conto Termico 3.0 è il meccanismo di incentivazione gestito dal GSE che rimborsa parte delle spese sostenute per interventi di efficientamento energetico e per la produzione di energia termica da fonti rinnovabili. Come ESCo certificata, Gruppo CB progetta l'intervento, cura la pratica e ti accompagna fino all'erogazione dell'incentivo.",
            interventionsTitle: "Interventi incentivabili",
            interventions: [
                { t: "Pompe di calore", d: "Sostituzione di impianti con pompe di calore ad alta efficienza." },
                { t: "Caldaie a biomassa", d: "Generatori a biomassa per riscaldamento ad alto rendimento." },
                { t: "Solare termico", d: "Collettori solari per acqua calda sanitaria e riscaldamento." },
                { t: "Scaldacqua a pompa di calore", d: "Produzione efficiente di acqua calda sanitaria." },
                { t: "Ibridi e sistemi evoluti", d: "Soluzioni integrate rinnovabili + termoregolazione." },
                { t: "Involucro ed efficienza", d: "Interventi di riqualificazione energetica per la PA." },
            ],
            beneficiariesTitle: "Chi può accedere",
            beneficiaries: [
                "Privati e condomìni",
                "Imprese e attività produttive",
                "Pubbliche Amministrazioni ed enti",
            ],
            advantagesTitle: "I vantaggi",
            advantages: [
                { t: "Fino al 65%", d: "Rimborso della spesa a seconda dell'intervento." },
                { t: "Erogazione rapida", d: "Rimborso in rate annuali o in un'unica soluzione." },
                { t: "Pratica chiavi in mano", d: "Gestiamo noi la domanda al GSE per te." },
            ],
            cta: "Verifica se hai diritto all'incentivo",
        },
        certifications: {
            chapter: "Qualità e Conformità",
            title: "Le Nostre Certificazioni",
            sub: "Competenze riconosciute e conformità alle normative: la garanzia di lavori a regola d'arte.",
            items: {
                soa: { name: "Attestazione SOA", desc: "Qualificazione per lavori pubblici — categorie OS 3 I e OS 28 III-BIS." },
                rina: { name: "ISO 9001 — RINA", desc: "Sistema di gestione per la qualità certificato (CISQ / IQNET)." },
                fgas: { name: "F-GAS", desc: "Certificazione per la gestione dei gas fluorurati negli impianti di climatizzazione." },
                albo: { name: "Albo Nazionale Gestori Ambientali", desc: "Iscrizione per la gestione e il trasporto dei rifiuti." },
                raee: { name: "Centro di Coordinamento RAEE", desc: "Gestione conforme dei rifiuti da apparecchiature elettriche ed elettroniche." },
                itec: { name: "ITEC — Accredia", desc: "Certificazione di prodotto accreditata Accredia." },
                kiwa: { name: "Kiwa Certified — Accredia", desc: "Certificazione di prodotto Kiwa accreditata Accredia." },
            },
        },
        team: {
            chapter: "Le Persone",
            title: "La Nostra Squadra",
            sub: "Il valore di Gruppo CB sono le persone: tecnici qualificati, progettisti e amministrativi uniti dalla passione per il lavoro ben fatto.",
            p1: "Dietro ogni impianto c'è un team affiatato di professionisti. Dalla progettazione alla posa, dall'assistenza tecnica alla gestione amministrativa, ogni membro della squadra mette competenza, aggiornamento continuo e cura del dettaglio al servizio del cliente.",
            p2: "Un gruppo che cresce insieme, condividendo obiettivi e traguardi — perché la qualità di un impianto nasce prima di tutto dalle persone che lo realizzano.",
            stats: [
                { value: 20, suffix: "+", label: "Professionisti" },
                { value: 2001, suffix: "", label: "Dal" },
                { value: 100, suffix: "%", label: "Team certificato" },
            ],
            photoCaption: "Il team di Gruppo CB",
        },
        whatsapp: "Scrivici su WhatsApp",
        loader: "Impianti per il futuro",
        mapSection: {
            chapter: "Copertura Territoriale",
            title: "Dove Operiamo",
            sub: "Esplora la mappa e clicca sui punti per scoprire i lavori realizzati in ogni zona. Operiamo in tutta Italia.",
            hint: "Clicca su un punto per i dettagli",
            works: "Lavori realizzati",
            projectsWord: "progetti",
        },
        simulator: {
            title: "Simulatore Risparmio & Conto Termico",
            sub: "Scopri in pochi secondi quanto potresti risparmiare e a quale incentivo potresti accedere. Come ESCo certificata, ti guidiamo fino all'erogazione.",
            intervention: "Tipo di intervento",
            beneficiary: "Chi sei",
            zone: "Zona climatica",
            zones: { nord: "Nord", centro: "Centro", sud: "Sud" },
            annualSpend: "Spesa energetica annua",
            interventionCost: "Spesa prevista per l'intervento",
            interventions: { heatpump: "Pompa di calore", biomass: "Caldaia a biomassa", solar: "Solare termico", pv: "Fotovoltaico", hybrid: "Sistema ibrido" },
            beneficiaries: { private: "Privato", business: "Azienda", pa: "Ente pubblico" },
            resultsTitle: "Stima dei risultati",
            saving: "Risparmio annuo stimato",
            incentive: "Incentivo Conto Termico",
            co2: "CO₂ evitata all'anno",
            payback: "Rientro investimento",
            tenYear: "Risparmio in 10 anni",
            netCost: "Costo netto stimato",
            years: "anni",
            perYear: "/anno",
            disclaimer: "Stima puramente indicativa e non vincolante, basata su parametri medi di mercato. Contattaci per una valutazione tecnica personalizzata.",
            cta: "Richiedi una valutazione gratuita",
        },
        configurator: {
            title: "Configura il tuo preventivo",
            sub: "Rispondi a poche domande: prepareremo una proposta su misura per te.",
            step: "Passo", of: "di",
            next: "Avanti", back: "Indietro", submit: "Invia richiesta", sending: "Invio...",
            success: "Richiesta inviata! Ti ricontatteremo al più presto con una proposta su misura.",
            error: "Errore nell'invio. Riprova o chiamaci.",
            restart: "Nuova richiesta",
            q1: "Di che impianto hai bisogno?",
            q2: "Per quale tipo di edificio?",
            q3: "Qual è la dimensione dell'intervento?",
            q4: "Entro quando vorresti realizzarlo?",
            q5: "Lasciaci i tuoi contatti",
            buildings: { home: "Abitazione privata", condo: "Condominio", business: "Azienda / Industria", public: "Ente pubblico" },
            sizes: { s: "Fino a 100 m²", m: "100 – 300 m²", l: "300 – 1000 m²", xl: "Oltre 1000 m²" },
            timings: { urgent: "Urgente", soon: "1 – 3 mesi", mid: "3 – 6 mesi", eval: "Sto valutando" },
            name: "Nome e cognome", email: "Email", phone: "Telefono", notes: "Note (opzionale)",
            summary: "Riepilogo della tua richiesta", required: "Compila nome ed email",
        },
        preventivoPage: {
            chapter: "Preventivo",
            title: "Richiedi il tuo Preventivo",
            sub: "Usa il configuratore guidato per una proposta su misura, o simula il tuo risparmio energetico.",
            tabConfig: "Configuratore Preventivo",
            tabSim: "Simulatore Risparmio",
        },
        seo: {
            home: { t: "Impianti Tecnologici per il Futuro", d: "Gruppo CB srl: dal 2001 progettiamo e realizziamo impianti idraulici, termici, di climatizzazione, antincendio e fotovoltaici per aziende, industrie ed enti pubblici in tutta Italia." },
            services: { t: "I Nostri Servizi", d: "Impianti idraulici, termici, climatizzazione, antincendio, fotovoltaico e manutenzioni: soluzioni civili e industriali realizzate a regola d'arte da Gruppo CB." },
            projects: { t: "Progetti Realizzati", d: "Scopri i progetti realizzati da Gruppo CB: impianti termici, fotovoltaici, di climatizzazione, idraulici e antincendio per clienti civili, industriali e pubblici." },
            contact: { t: "Contatti", d: "Contatta Gruppo CB srl per preventivi, sopralluoghi e consulenze. Via dei Contadini 48, San Martino in Colle (PG) — Tel. 075 9979639." },
            contoTermico: { t: "Conto Termico 3.0", d: "Accedi al Conto Termico 3.0 con Gruppo CB, ESCo certificata: incentivi GSE fino al 65% per pompe di calore, biomassa, solare termico ed efficienza energetica." },
            certifications: { t: "Certificazioni", d: "Le certificazioni di Gruppo CB: SOA, ISO 9001 RINA, F-GAS, Albo Gestori Ambientali, RAEE, ITEC e Kiwa Accredia. Qualità e conformità garantite." },
            team: { t: "La Nostra Squadra", d: "Conosci il team di Gruppo CB: tecnici qualificati, progettisti e personale amministrativo al servizio dei tuoi impianti dal 2001." },
            preventivo: { t: "Richiedi Preventivo", d: "Configura online il tuo preventivo su misura e simula il risparmio energetico con il Conto Termico. Gruppo CB, ESCo certificata." },
        },
    },
    en: {
        nav: { home: "Home", services: "Services", projects: "Projects", contact: "Contact", quote: "Request a Quote", company: "Company", team: "Our Team", certifications: "Certifications", contoTermico: "Conto Termico 3.0" },
        hero: {
            overline: "Technological systems · since 2001",
            l1: "We build technological",
            l2: "systems",
            l3: "for the future.",
            sub: "For over 20 years we have designed and built plumbing, heating, fire protection and technological systems for companies, industries and public bodies.",
            cta1: "Request a Quote",
            cta2: "Our Work",
            scroll: "Scroll",
        },
        about: {
            chapter: "01 — About Us",
            title: "Experience, Innovation and Quality",
            p1: "Gruppo CB srl has operated in the systems sector since 2001. We install and repair plumbing, heating, gas and air-conditioning systems.",
            p2: "We work throughout Italy with specialised personnel. Our constant technical training translates into the search for innovative, cutting-edge products.",
            stats: [
                { value: 20, suffix: "+", label: "Years of experience" },
                { value: 500, suffix: "+", label: "Systems delivered" },
                { value: 100, suffix: "%", label: "Qualified team" },
                { value: 24, suffix: "/7", label: "Continuous support" },
            ],
        },
        services: { chapter: "02 — Services", title: "What We Build", sub: "Complete civil and industrial systems solutions.", more: "Learn more" },
        why: {
            chapter: "03 — Why Choose Us",
            title: "Why choose Gruppo CB",
            items: {
                certified: "Certified personnel",
                quality: "Quality materials",
                innovation: "Innovative technologies",
                compliance: "Regulatory compliance",
                onTime: "Guaranteed deadlines",
                aftersales: "After-sales support",
            },
        },
        esco: {
            chapter: "ESCo Certification",
            badge: "UNI CEI 11352",
            title: "Certified Energy Service Company",
            p: "Gruppo CB is a certified ESCo (Energy Service Company) under the UNI CEI 11352 standard. We don't just install systems: we design and deliver energy-efficiency projects that guarantee results, manage incentives and offer financing solutions.",
            items: [
                { t: "Energy audit & design", d: "Consumption analysis and tailored efficiency plans." },
                { t: "Guaranteed savings", d: "Results secured through Energy Performance Contracts (EPC)." },
                { t: "Incentive management", d: "White Certificates (TEE), Conto Termico and tax deductions." },
                { t: "Third-party financing", d: "Projects delivered with no upfront investment from the client." },
            ],
            cta: "Discover how to save energy",
        },
        portfolio: { chapter: "04 — Portfolio", title: "Our Work", sub: "A selection of delivered projects.", all: "All", view: "View all projects" },
        clients: { title: "Companies and partners who chose us" },
        reviews: { chapter: "05 — Testimonials", title: "What our clients say" },
        offices: {
            chapter: "06 — Our Offices",
            title: "Our Offices",
            sub: "Modern, welcoming spaces where our projects come to life. Hover (or tap) to explore.",
            hint: "Hover to explore",
            items: [
                { tag: "Workspaces", title: "Bright Offices", desc: "Modern work environments with glass partitions and designer finishes, built for focus and collaboration." },
                { tag: "Reception", title: "Gruppo CB Welcome", desc: "A polished, branded entrance where we welcome clients and partners with professionalism." },
                { tag: "Client Area", title: "Comfort & Design", desc: "Comfortable, tidy spaces that reflect our company's care and attention to detail." },
            ],
        },
        finalCta: { title: "Have a project in mind?", sub: "Contact us for a free, no-obligation consultation.", btn: "Request a Free Quote" },
        servicesPage: { title: "Our Services", sub: "Civil and industrial systems designed and built to the highest standards.", process: "Work process", faq: "Frequently asked questions", benefits: "Benefits", askQuote: "Request a quote for this service" },
        process: [
            { t: "Planning", d: "Needs analysis and tailored design." },
            { t: "Procurement", d: "Selection of certified, cutting-edge materials." },
            { t: "Execution", d: "Installation with specialised personnel." },
            { t: "Coordination", d: "Project management at every stage." },
            { t: "Testing", d: "Legally compliant checks and tests." },
            { t: "Delivery", d: "Completed system and ongoing support." },
        ],
        faq: [
            { q: "Which areas do you cover?", a: "We work throughout Italy with specialised personnel, with operational headquarters in Umbria." },
            { q: "Do you issue certifications?", a: "Yes, all our systems are tested and certified according to law." },
            { q: "Do you offer after-sales support?", a: "Of course. We are an authorised Ariston, Ferroli and Haier service centre with scheduled maintenance contracts." },
            { q: "Can I access incentives?", a: "We support you in accessing incentives such as the Conto Termico for energy efficiency." },
        ],
        projectsPage: { title: "Projects", sub: "Filter by category and explore our delivered work.", year: "Year", client: "Client", tech: "Technologies" },
        contactPage: {
            title: "Contact", sub: "We are at your disposal for quotes, site visits and consultations.",
            phone: "Phone", email: "Email", address: "Address", hours: "Hours",
            hoursValue: "Mon–Fri 8:00–18:00 · Sat by appointment",
        },
        form: {
            name: "Full name", email: "Email", phone: "Phone", service: "Service of interest", subject: "Subject", message: "Message",
            send: "Send request", sending: "Sending...", selectService: "Select a service",
            success: "Request sent! We will get back to you soon.", error: "Sending error. Please retry or call us.",
            required: "Required field",
        },
        footer: { tagline: "Civil and industrial systems · plumbing, heating, gas and air-conditioning.", nav: "Navigation", services: "Services", contacts: "Contacts", rights: "All rights reserved.", quote: "Request a quote or a site visit" },
        contoTermico: {
            chapter: "Incentives",
            title: "Conto Termico 3.0",
            sub: "The state incentive for energy efficiency and thermal renewables. We handle everything from design to the GSE application.",
            intro: "Conto Termico 3.0 is the incentive scheme managed by the GSE that reimburses part of the costs for energy-efficiency measures and thermal energy production from renewable sources. As a certified ESCo, Gruppo CB designs the intervention, manages the paperwork and supports you all the way to receiving the incentive.",
            interventionsTitle: "Eligible interventions",
            interventions: [
                { t: "Heat pumps", d: "Replacing systems with high-efficiency heat pumps." },
                { t: "Biomass boilers", d: "High-efficiency biomass generators for heating." },
                { t: "Solar thermal", d: "Solar collectors for domestic hot water and heating." },
                { t: "Heat-pump water heaters", d: "Efficient domestic hot water production." },
                { t: "Hybrid & advanced systems", d: "Integrated renewable + thermal-regulation solutions." },
                { t: "Building envelope & efficiency", d: "Energy retrofit works for public administration." },
            ],
            beneficiariesTitle: "Who can apply",
            beneficiaries: [
                "Private individuals and condominiums",
                "Companies and production activities",
                "Public administrations and bodies",
            ],
            advantagesTitle: "The benefits",
            advantages: [
                { t: "Up to 65%", d: "Reimbursement of costs depending on the intervention." },
                { t: "Fast payout", d: "Reimbursement in annual instalments or a lump sum." },
                { t: "Turnkey paperwork", d: "We manage the GSE application for you." },
            ],
            cta: "Check if you qualify for the incentive",
        },
        certifications: {
            chapter: "Quality & Compliance",
            title: "Our Certifications",
            sub: "Recognised expertise and regulatory compliance: the guarantee of work done to the highest standard.",
            items: {
                soa: { name: "SOA Attestation", desc: "Qualification for public works — categories OS 3 I and OS 28 III-BIS." },
                rina: { name: "ISO 9001 — RINA", desc: "Certified quality management system (CISQ / IQNET)." },
                fgas: { name: "F-GAS", desc: "Certification for handling fluorinated gases in air-conditioning systems." },
                albo: { name: "National Register of Environmental Managers", desc: "Registration for waste management and transport." },
                raee: { name: "RAEE Coordination Centre", desc: "Compliant management of waste electrical and electronic equipment." },
                itec: { name: "ITEC — Accredia", desc: "Accredia-accredited product certification." },
                kiwa: { name: "Kiwa Certified — Accredia", desc: "Kiwa product certification accredited by Accredia." },
            },
        },
        team: {
            chapter: "The People",
            title: "Our Team",
            sub: "Gruppo CB's true value is its people: qualified technicians, designers and administrative staff united by a passion for work done right.",
            p1: "Behind every system there is a close-knit team of professionals. From design to installation, from technical support to administrative management, every team member brings expertise, continuous training and attention to detail to serve the client.",
            p2: "A group that grows together, sharing goals and milestones — because the quality of a system starts, above all, with the people who build it.",
            stats: [
                { value: 20, suffix: "+", label: "Professionals" },
                { value: 2001, suffix: "", label: "Since" },
                { value: 100, suffix: "%", label: "Certified team" },
            ],
            photoCaption: "The Gruppo CB team",
        },
        whatsapp: "Message us on WhatsApp",
        loader: "Systems for the future",
        mapSection: {
            chapter: "Territorial Coverage",
            title: "Where We Operate",
            sub: "Explore the map and click the points to discover the works carried out in each area. We operate throughout Italy.",
            hint: "Click a point for details",
            works: "Completed works",
            projectsWord: "projects",
        },
        simulator: {
            title: "Savings & Conto Termico Simulator",
            sub: "Find out in seconds how much you could save and which incentive you could access. As a certified ESCo, we guide you all the way to the payout.",
            intervention: "Type of intervention",
            beneficiary: "Who you are",
            zone: "Climate zone",
            zones: { nord: "North", centro: "Centre", sud: "South" },
            annualSpend: "Annual energy spend",
            interventionCost: "Estimated intervention cost",
            interventions: { heatpump: "Heat pump", biomass: "Biomass boiler", solar: "Solar thermal", pv: "Photovoltaic", hybrid: "Hybrid system" },
            beneficiaries: { private: "Private", business: "Company", pa: "Public body" },
            resultsTitle: "Estimated results",
            saving: "Estimated annual saving",
            incentive: "Conto Termico incentive",
            co2: "CO₂ avoided per year",
            payback: "Payback period",
            tenYear: "10-year saving",
            netCost: "Estimated net cost",
            years: "years",
            perYear: "/yr",
            disclaimer: "Purely indicative, non-binding estimate based on average market parameters. Contact us for a personalised technical assessment.",
            cta: "Request a free assessment",
        },
        configurator: {
            title: "Configure your quote",
            sub: "Answer a few questions: we'll prepare a tailored proposal for you.",
            step: "Step", of: "of",
            next: "Next", back: "Back", submit: "Send request", sending: "Sending...",
            success: "Request sent! We'll get back to you soon with a tailored proposal.",
            error: "Sending error. Please retry or call us.",
            restart: "New request",
            q1: "Which system do you need?",
            q2: "For which type of building?",
            q3: "What is the size of the intervention?",
            q4: "When would you like it done?",
            q5: "Leave us your contact details",
            buildings: { home: "Private home", condo: "Condominium", business: "Company / Industry", public: "Public body" },
            sizes: { s: "Up to 100 m²", m: "100 – 300 m²", l: "300 – 1000 m²", xl: "Over 1000 m²" },
            timings: { urgent: "Urgent", soon: "1 – 3 months", mid: "3 – 6 months", eval: "Just exploring" },
            name: "Full name", email: "Email", phone: "Phone", notes: "Notes (optional)",
            summary: "Summary of your request", required: "Please fill in name and email",
        },
        preventivoPage: {
            chapter: "Quote",
            title: "Request your Quote",
            sub: "Use the guided configurator for a tailored proposal, or simulate your energy savings.",
            tabConfig: "Quote Configurator",
            tabSim: "Savings Simulator",
        },
        seo: {
            home: { t: "Technological Systems for the Future", d: "Gruppo CB srl: since 2001 we design and build plumbing, heating, air-conditioning, fire-protection and photovoltaic systems for companies, industries and public bodies across Italy." },
            services: { t: "Our Services", d: "Plumbing, heating, air-conditioning, fire protection, photovoltaic systems and maintenance: civil and industrial solutions built to the highest standards by Gruppo CB." },
            projects: { t: "Completed Projects", d: "Explore projects delivered by Gruppo CB: heating, photovoltaic, air-conditioning, plumbing and fire-protection systems for civil, industrial and public clients." },
            contact: { t: "Contact", d: "Contact Gruppo CB srl for quotes, site visits and consultations. Via dei Contadini 48, San Martino in Colle (PG), Italy — Tel. +39 075 9979639." },
            contoTermico: { t: "Conto Termico 3.0", d: "Access Conto Termico 3.0 with Gruppo CB, a certified ESCo: GSE incentives up to 65% for heat pumps, biomass, solar thermal and energy efficiency." },
            certifications: { t: "Certifications", d: "Gruppo CB certifications: SOA, ISO 9001 RINA, F-GAS, Environmental Managers Register, RAEE, ITEC and Kiwa Accredia. Guaranteed quality and compliance." },
            team: { t: "Our Team", d: "Meet the Gruppo CB team: qualified technicians, designers and administrative staff serving your systems since 2001." },
            preventivo: { t: "Request a Quote", d: "Configure your tailored quote online and simulate your energy savings with Conto Termico. Gruppo CB, a certified ESCo." },
        },
    },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState("it");
    const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : "it")), []);
    const t = STRINGS[lang];
    return (
        <LangContext.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LangContext.Provider>
    );
}

export function useLang() {
    const ctx = useContext(LangContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
}
